import { toast } from "react-toastify"

type Props = {
    mensagem: string,
    type: "success" | "error" | "info" | "warning"
}

class ToastCustom {
    id: any

    loading(msg = 'Salvando') {
        this.id = toast.loading(msg)
    }

    update({ mensagem, type }: Props) {
        toast.update(this.id, { render: mensagem, type: type, isLoading: false, autoClose: 3000 });
    }

    show({ mensagem, type }: Props) {
        toast[type](mensagem, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

    }
}

export default new ToastCustom()